import React from 'react';
import { Container, Row, Col } from 'reactstrap'
import Supplier from '../../Editors/Supplier.tsx';

const MoveStaffToSupplier = () => <React.Fragment>
    <Container>
        <Row>
            <Col>
                <Supplier />
            </Col>
        </Row>
    </Container>
</React.Fragment>


export default MoveStaffToSupplier;